// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1lVMo","rootSmall":"AddTileButton_rootSmall__3qYU0"};